var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout-container"},[_c('el-header',{staticClass:"layout-header"},[_c('Header')],1),_c('el-container',{staticClass:"layout-content"},[_c('Aside'),_c('Main')],1),_c('KeyboardShortcuts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }